// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"bfbe2ea1","453":"2b0627e5"}[chunkId] + ".chunk.js";
};